export default __webpack_public_path__ + "images/525203145c6faa467f45fdfdc72f1f86-4_tablet_1067x470.jpg";